import styled from 'styled-components';

export const Container = styled.div`
    background-color: white;
    padding: 6rem 0;
    border-bottom: 1px solid #f3f4f6;
`;

export const Content = styled.div`
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1rem;
    text-align: center;
`;

export const MainHeadline = styled.h2`
    font-size: 3.75rem;
    font-weight: 800;
    color: #735BF2;
    margin-bottom: 1rem;
    letter-spacing: -0.05em;

    @media (min-width: 768px) {
        font-size: 6rem;
    }
`;

export const Subtitle = styled.p`
    font-size: 1.25rem;
    color: #111827;
    font-weight: 500;
    margin-bottom: 4rem;
`;

export const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 3rem;

    @media (min-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
    }
`;

export const StatItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: transform 200ms ease;

    &:hover {
        transform: translateY(-4px);
    }
`;

export const StatNumber = styled.span`
    font-size: 2.25rem;
    font-weight: 800;
    color: #111827;
    margin-bottom: 0.5rem;

    @media (min-width: 768px) {
        font-size: 2.5rem;
    }
`;

export const StatLabel = styled.span`
    color: #6b7280;
    font-weight: 500;
    font-size: 1rem;
`;
